
<div class="container-fluid careers_section">

  <div class="container">
    <div class="custom-container">
      <div class="row py-5">

        <div class="col-lg-6 p-lg-5">
          <div data-aos="fade-up" data-aos-duration="2000">
            <h2 class="text-uppercase m-0 py-3 text-white">careers</h2>
            <div class="py-3 text-white">
              <h6>Join the Best Team of Experts</h6>
              <p class="text-white">Together we Dream, Aspire and Create Opportunities for people to grow in Career.</p>
            </div>
            <h3 class="text-uppercase text-white">we are hiring now</h3>
          </div>
          <div class="d-flex justify-content-start py-4" data-aos="fade-up" data-aos-duration="3000">
            <a class="customBtn text-decoration-none px-4 text-uppercase" href="/career" role="button">Click to view all Job Openings...</a>
          </div>
        </div>

        <div class="col-lg-6 p-lg-5">
          <img class="img-fluid" data-aos="fade-up" data-aos-duration="2000" src="../../assets/images/carrer_fullsize.jpg" alt="career">
        </div>
      </div>
<div class="row py-5 mb-5">
        <div class="col-lg-6">
          <img class="img-fluid" data-aos="fade-up" data-aos-duration="2000" src="../../assets/images/letstalk.png" alt="letstalk">

        </div>
        <div class="col-lg-6 letHelp my-auto">

        <div class="my-auto px-lg-5 shareQueries" data-aos="fade-up" data-aos-duration="2000">
          <h2 class="text-uppercase m-0 py-3 lineHeight text-white">let's help you for your queries</h2>
          <p>Share your queries. We are looking forward to your message.</p>
          <div class="d-flex justify-content-start py-4">
            <a href="/reach-us"  class="customBtn text-decoration-none px-5 text-uppercase" role="button"> Contact Us...</a>
          </div>
        </div>

        </div>
      </div>


    </div>
  </div>



</div>
